import { ProductCard } from './ProductCard';
import { priceFor, pricingPending } from '@/hooks/useCustomerPricing';
import type { CatalogItem } from '@/types/domain';

interface CatalogGridProps {
  items: CatalogItem[];
  pricing: Map<string, number> | undefined;
  cart: Record<string, number>;
  onAdjust: (id: string, delta: number) => void;
  onSet: (id: string, qty: number) => void;
}

export function CatalogGrid({ items, pricing, cart, onAdjust, onSet }: CatalogGridProps) {
  if (items.length === 0) {
    return (
      <div className="px-2 py-16 text-center">
        <p className="text-sm text-brix-muted">No items match your search.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
      {items.map((item) => {
        const { unitPrice, isCustom } = priceFor(item, pricing);
        return (
          <ProductCard
            key={item.id}
            item={item}
            unitPrice={unitPrice}
            isCustomPrice={isCustom}
            pricePending={pricingPending(pricing)}
            qty={cart[item.id] ?? 0}
            onAdjust={onAdjust}
            onSet={onSet}
          />
        );
      })}
    </div>
  );
}
